import React from "react";
import { connect } from "react-redux";
import { PacmanLoader } from "react-spinners";
import { Card, Row, Col } from "reactstrap";
import { FormattedMessage } from "react-intl";

import { fetchInvoiceHistory } from "../../actions/invoiceHistoryActions";
import InvoiceItem from "../../components/Invoice/InvoiceItem";

class TeacherInvoiceHistory extends React.Component {
  componentDidMount() {
    this.props.dispatch(fetchInvoiceHistory(localStorage.getItem("email")));
  }

  render() {
    const { invoiceHistory } = this.props;

    if (invoiceHistory.loading) {
      return (
        <div
          className="sweet-loading"
          style={{ position: "fixed", top: "50%", left: "50%" }}
        >
          <PacmanLoader color={"#20a8d8"} loading={true} />
        </div>
      );
    }

    if (invoiceHistory.result.length === 0) {
      return (
        <Row>
          <Col sm="6" md="10">
            <Card body>
              <FormattedMessage id="Views.Teacher.InvoiceHistory.NoInvoicesToShow" />
            </Card>
          </Col>
        </Row>
      );
    }

    return (
      <div className="animated fadeIn">
        {invoiceHistory.result.map((invoice, i) => {
          return (
            <InvoiceItem key={i} invoice={invoice} fortNoxDisplay={false} />
          );
        })}
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    invoiceHistory: store.invoiceHistoryReducer,
  };
};

export default connect(mapStateToProps)(TeacherInvoiceHistory);
